import React from "react";

const ImageRadio = ({
  label,
  required = true,
  name,
  currentValue,
  radios = [],
  onChange,
  path = "/img/widget-icons/",
  ext = ".svg",
  isManager = false,
}) => {
  return (
    <div>
      {label && (
        <label
          style={{ fontSize: "12px" }}
          className={`label${required ? " req" : ""}`}
          htmlFor={name}
        >
          {label}
        </label>
      )}
      <div
        className={
          isManager
            ? "radio-group image widgets-padding-top"
            : "radio-group image"
        }
      >
        {radios.map((image) => (
          <label className="image-radio" key={image}>
            <input
              name={name}
              id={image}
              type="radio"
              value={image}
              className="radio"
              onChange={onChange}
              checked={currentValue === image}
            />
            <div className="radio-img" style={{ display: "flex" }}>
              <img src={`${path}${image}${ext}`} />
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ImageRadio;
